export default __webpack_public_path__ + "static/media/unbound_logo1.7f317704.png";